module.exports = __webpack_public_path__ + "img/show_tc_text_9.2d5e672c.png";